import commitMutation from 'relay-commit-mutation-promise';
import { graphql } from 'react-relay';

const mutation = graphql`
    mutation requestShipmentQuoteMutation($input: ShipmentQuoteRequestInput!) {
        shipmentQuoteRequest(input: $input) {
            conversation {
                id
                serviceId
                transaction {
                    id
                    serviceId
                }
            }
        }
    }
`;

export function requestShipmentQuoteMutation(environment, args) {
    const { userId, itemId, dealerPk, address, action, subject, message } = args;

    const input = {
        // required fields:
        buyerId: userId,
        itemPk: itemId,
        dealerPk: dealerPk,
        subject,
        message,
        // optional fields:
        shippingAddressId: address.serviceId,
        action,
    };

    return commitMutation(environment, {
        mutation,
        variables: { input },
    });
}
